import { useState, useRef } from "react";
import { Row, Col, DropdownButton, Dropdown } from "react-bootstrap";
import Loader from "../../components/loader";
import UiButton from "../../components/button";
import TextInput from "../../components/textinput/TextInput";
import {
  useSupportedTokens,
  useSecurityTokenDetails,
  useNetworkOptions,
} from "../../context/contractDataLoaderService";
import {
  PrimaryIssueManager,
  SecuritiesFactory,
  contractAddress,
  Security,
  MarginIssueManager,
  ERC20 as TOKEN,
} from "@verified-network/verified-sdk";
import Web3 from "web3";
import { useGlobal, fetchSumsubAccessToken } from "../../context/globalContext";
import ERC20ABI from "../../utils/abi/ERC20.json";

import { create } from "ipfs-http-client";
import {
  SuccessToast,
  FailureToast,
  ToastOptions,
  auth,
  networks,
  BrokeragesList,
  networkLoanConstant,
} from "../../utils/constants";
import { toast } from "react-toastify";
import ERC20 from "../../utils/abi/ERC20.json";
import { Route, useHistory } from "react-router-dom";
import { useAccount, useClient, useConnectorClient } from "wagmi";
import {
  getProviderNetwork,
  getProvider,
  getWeb3,
} from "../../utils/helpers/networks";
import { ethers, providers } from "ethers";
import { getAllVerifiedCashBalances, getKycStatus } from "../../utils/helpers";
const BigNumber = require("bignumber.js");

function NewProduct(props) {
  const history = useHistory();
  const {
    userRole,
    userAddress,
    connectedChainId,
    connectedProvider,
    connectedSigner,
    connectedWeb3,
    kycStatus,
    verifiedWalletDetails,
  } = useGlobal();

  const address = userAddress;
  const account = userAddress;
  const chainId = connectedChainId;

  const provider = connectedProvider;

  const signer = connectedSigner;

  const web3 = connectedWeb3;
  let securityContract,
    currencyContract,
    marginManagerAddress,
    web3CurrencyContract,
    web3SecurityContract;
  if (provider && provider.getSigner && chainId && address && web3) {
    marginManagerAddress = contractAddress[chainId].BalancerMarginIssueManager;

    securityContract = new Security(signer, props.security);

    currencyContract = new TOKEN(signer, props.currency);

    web3CurrencyContract = new web3.eth.Contract(ERC20, props.currency);
    web3SecurityContract = new web3.eth.Contract(ERC20, props.security);
  }
  const { data: networkOptions } = useNetworkOptions();
  const [loading, setLoading] = useState(false);
  const [securityAmount, setSecurityAmount] = useState(0);
  const [currencyAmount, setCurrencyAmount] = useState(0);
  const [minimumAmount, setMinimumAmount] = useState(0);
  const [marginAmount, setMarginAmount] = useState(0);
  const [collateralAmount, setCollateralAmount] = useState(0);
  const [tradeFee, setTradeFee] = useState(0);
  const [brokerageAmount, setBrokerageAmount] = useState(0);
  const [brokerage, setBrokerage] = useState("Select Brokerage");
  const modalContent = useRef(null);

  const validateParams = () => {
    let validated = true;
    if (Number(securityAmount) === 0) {
      alert(`${props.securitySymbol} amount cannot be zero(0)`);
      validated = false;
    }
    if (Number(currencyAmount) === 0) {
      alert(`${props.currencySymbol} amount cannot be zero(0)`);
      validated = false;
    }
    if (Number(minimumAmount) === 0) {
      alert(`Minimum order size amount cannot be zero(0)`);
      validated = false;
    }
    if (Number(marginAmount) === 0) {
      alert(`Margin amount cannot be zero(0)`);
      validated = false;
    }
    if (Number(collateralAmount) === 0) {
      alert(`Collateral amount cannot be zero(0)`);
      validated = false;
    }
    if (Number(tradeFee) === 0) {
      alert(`Trade fee amount cannot be zero(0)`);
      validated = false;
    }
    if (brokerage === "Select Brokerage") {
      alert(`Select Brokerage`);
      validated = false;
    }
    if (Number(brokerageAmount) === 0) {
      alert(`Amount to transfer to Brokerage cannot be zero(0)`);
      validated = false;
    }
    return validated;
  };

  const handleCurrencyApprove = async (currencyAllowance) => {
    if (
      Number(currencyAllowance) < Number(currencyAmount) &&
      marginManagerAddress
    ) {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await currencyContract._getMeeQuote(
          cashTokens[0]?.address,
          "approve",
          [marginManagerAddress, currencyAmount?.toString()]
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await currencyContract
        .approve(
          marginManagerAddress,
          currencyAmount?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then(async (res) => {
          if (res?.status === 0) {
            toast.success("Currency Approve Successful", ToastOptions);
          } else {
            setLoading(false);
            toast.error(
              "Transactin to approve currency token failed",
              ToastOptions
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          err.message.includes("User denied transaction")
            ? toast.error("User Rejected Transaction", ToastOptions)
            : toast.error(
                "Transactin to approve currency token failed",
                ToastOptions
              );
        });
    }
  };

  const handleSecurityApprove = async (
    securityAllowance,
    currencyAllowance
  ) => {
    if (
      Number(securityAllowance) < Number(securityAmount) &&
      marginManagerAddress
    ) {
      let paymentToken;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await securityContract._getMeeQuote(
          cashTokens[0]?.address,
          "approve",
          [marginManagerAddress, securityAmount?.toString()]
        );

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await securityContract
        .approve(
          marginManagerAddress,
          securityAmount?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
              }
            : {}
        )
        .then(async (res) => {
          if (res?.status === 0) {
            toast.success("Security Approve Successful", ToastOptions);
            await handleCurrencyApprove(currencyAllowance);
          } else {
            setLoading(false);
            toast.error(
              "Transactin to approve security token failed",
              ToastOptions
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          err.message.includes("User denied transaction")
            ? toast.error("User Rejected Transaction", ToastOptions)
            : toast.error(
                "Transactin to approve security token failed",
                ToastOptions
              );
        });
    } else {
      await handleCurrencyApprove(currencyAllowance);
    }
  };

  const handleWhiteListAndApprove = async (
    securityAllowance,
    currencyAllowance
  ) => {
    setLoading(true);
    //TODO: confirm this
    //since whitelist has to be called before you can approve security
    // if allowance amount is higher should whitelist be ignored???
    if (marginManagerAddress) {
      let paymentToken;
      let gasLimit;

      if (
        verifiedWalletDetails &&
        Object?.keys(verifiedWalletDetails)?.length > 0
      ) {
        const cashTokens = await getAllVerifiedCashBalances(
          chainId,
          web3,
          account
        );

        if (!cashTokens || cashTokens?.length === 0) {
          setLoading(false);
          toast.error(
            "No valid Cash Token on this network. Change network and try again.",
            ToastOptions
          );

          return;
        }
        paymentToken = cashTokens[0];
        const txQuote = await securityContract._getMeeQuote(
          cashTokens[0]?.address,
          "whiteList",
          [marginManagerAddress, securityAmount]
        );

        gasLimit = txQuote?.gasLimit;

        if (
          Number(cashTokens[0]?.balance) === 0 ||
          Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
        ) {
          setLoading(false);
          toast.error(
            `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
            ToastOptions
          );

          return;
        }
      }

      await securityContract
        .whiteList(
          marginManagerAddress,
          securityAmount?.toString(),
          paymentToken?.address
            ? {
                paymentToken: paymentToken?.address,
                apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                gasLimit,
              }
            : {}
        )
        .then(async (e) => {
          if (e?.status === 0) {
            toast.success("Whitelist Successful", ToastOptions);
            await handleSecurityApprove(securityAllowance, currencyAllowance);
          } else {
            setLoading(false);
            toast.error("WhiteList transaction failed", ToastOptions);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("WhiteList transaction failed", ToastOptions);
        });
    }
  };

  const handleIssueProduct = async () => {
    const isValidated = validateParams();
    if (isValidated && marginManagerAddress && address && web3 && chainId) {
      const userKycStatus = await getKycStatus(address, chainId, web3);
      if (userKycStatus !== 3) {
        const data = await fetchSumsubAccessToken(account, chainId);
        props.setIssuedSecurityModal(false);
        props.setshowKYCModal(true);
        props.setAccessToken(data.accessToken);
        return;
      }
      const securityAllowance = await web3SecurityContract.methods
        .allowance(account, marginManagerAddress)
        .call();
      const currencyAllowance = await web3CurrencyContract.methods
        .allowance(account, marginManagerAddress)
        .call();
      const marginManagerContract = new MarginIssueManager(
        signer,
        marginManagerAddress
      );
      await handleWhiteListAndApprove(
        securityAllowance,
        currencyAllowance
      ).then(async () => {
        let paymentToken;

        if (
          verifiedWalletDetails &&
          Object?.keys(verifiedWalletDetails)?.length > 0
        ) {
          const cashTokens = await getAllVerifiedCashBalances(
            chainId,
            web3,
            account
          );

          if (!cashTokens || cashTokens?.length === 0) {
            setLoading(false);
            toast.error(
              "No valid Cash Token on this network. Change network and try again.",
              ToastOptions
            );

            return;
          }
          paymentToken = cashTokens[0];

          const txQuote = await marginManagerContract._getMeeQuote(
            cashTokens[0]?.address,
            "issueProduct",
            [
              props.security,
              ethers.utils.formatBytes32String(
                web3.utils.asciiToHex(props.productCategory)
              ),
              props.currency,
              ethers.utils.formatBytes32String(
                web3.utils.asciiToHex(brokerage)
              ),
              securityAmount,
              minimumAmount,
              currencyAmount,
              marginAmount,
              collateralAmount,
              tradeFee,
            ]
          );

          if (
            Number(cashTokens[0]?.balance) === 0 ||
            Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
          ) {
            setLoading(false);
            toast.error(
              `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
              ToastOptions
            );

            return;
          }
        }

        await marginManagerContract
          .issueProduct(
            props.security,
            web3.utils.asciiToHex(props.productCategory),
            props.currency,
            web3.utils.asciiToHex(brokerage),
            securityAmount,
            minimumAmount,
            currencyAmount,
            marginAmount,
            collateralAmount,
            tradeFee,
            paymentToken?.address
              ? {
                  paymentToken: paymentToken?.address,
                  apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                }
              : {}
          )
          .then(async (res) => {
            if (res?.status === 0) {
              const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res.response.hash}`;
              toast.success(
                SuccessToast(
                  transactionLink,
                  "Margin Product Issued Succesfully"
                ),
                ToastOptions
              );
              const brokerages = networkLoanConstant[chainId]?.Brokerages;
              if (
                brokerages &&
                brokerages[brokerage?.toUpperCase()] &&
                Number(brokerageAmount) > 0
              ) {
                const securityContractN = new TOKEN(signer, props.security);
                let paymentToken;

                if (
                  verifiedWalletDetails &&
                  Object?.keys(verifiedWalletDetails)?.length > 0
                ) {
                  const cashTokens = await getAllVerifiedCashBalances(
                    chainId,
                    web3,
                    account
                  );

                  if (!cashTokens || cashTokens?.length === 0) {
                    setLoading(false);
                    toast.error(
                      "No valid Cash Token on this network. Change network and try again.",
                      ToastOptions
                    );

                    return;
                  }
                  paymentToken = cashTokens[0];
                  const txQuote = await securityContractN._getMeeQuote(
                    cashTokens[0]?.address,
                    "transfer",
                    [
                      brokerages[brokerage?.toUpperCase()],
                      brokerageAmount?.toString(),
                    ]
                  );

                  if (
                    Number(cashTokens[0]?.balance) === 0 ||
                    Number(txQuote?.amount) > Number(cashTokens[0]?.balanceFmt)
                  ) {
                    setLoading(false);
                    toast.error(
                      `Insufficient ${cashTokens[0]?.name} balance. You need at least: ${txQuote?.amount}  ${cashTokens[0]?.name} to proceed.`,
                      ToastOptions
                    );

                    return;
                  }
                }

                await securityContractN
                  .transfer(
                    brokerages[brokerage?.toUpperCase()],
                    brokerageAmount?.toString(),
                    paymentToken?.address
                      ? {
                          paymentToken: paymentToken?.address,
                          apiKey: process.env.REACT_APP_BICONOMY_MEE_KEY,
                        }
                      : {}
                  )
                  .then((_res) => {
                    setLoading(false);
                    if (_res?.status === 0) {
                      const transactionLink = `${networks[chainId].blockExplorerUrls[0]}/tx/${res?.response?.hash}`;
                      toast.success(
                        SuccessToast(
                          transactionLink,
                          "Transfered Security to Brokerage succesfully"
                        ),
                        ToastOptions
                      );
                    } else {
                      toast.error(
                        SuccessToast(
                          transactionLink,
                          "Transfered Security to Brokerage failed"
                        ),
                        ToastOptions
                      );
                    }
                  })
                  .catch((err) => {
                    console.error("err: ", err);
                    setLoading(false);
                    toast.error(
                      "Transfered Security to Brokerage failed",
                      ToastOptions
                    );
                  });
              }

              history.push("/");
            } else {
              setLoading(false);
              toast.error("Issue Product transaction failed", ToastOptions);
            }
          })
          .catch((err) => {
            setLoading(false);
            toast.error("Issue Product transaction failed", ToastOptions);
          });
      });
    }
  };

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="d-grid gap-2" ref={modalContent}>
        <Row className="ml-1 align-items-center">
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              <b>{props.securitySymbol} Amount</b>
            </Col>
            <Col className="pl-0" xs={3.5}>
              <TextInput
                placeholder="Value of security tokens"
                fieldType="number"
                onChange={(e) =>
                  setSecurityAmount(web3.utils.toWei(e.target.value, "ether"))
                }
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              <b>{props.currencySymbol} Amount</b>
            </Col>
            <Col className="pl-0" xs={3.5}>
              <TextInput
                placeholder="Value of currency tokens"
                fieldType="number"
                onChange={async (e) => {
                  const amount = (
                    Number(e.target.value) *
                    10 **
                      Number(
                        await new web3.eth.Contract(
                          ERC20,
                          props.currency
                        ).methods
                          .decimals()
                          .call()
                      )
                  ).toString();
                  setCurrencyAmount(amount);
                }}
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              <b>Minimum Order Size</b>
            </Col>
            <Col className="pl-0" xs={3.5}>
              <TextInput
                placeholder="Value of Minimum Order"
                fieldType="number"
                onChange={(e) =>
                  setMinimumAmount(web3.utils.toWei(e.target.value, "ether"))
                }
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              <b>Margin Amount</b>
            </Col>
            <Col className="pl-0" xs={3.5}>
              <TextInput
                placeholder="Value of Margin in %"
                fieldType="number"
                onChange={(e) =>
                  setMarginAmount(web3.utils.toWei(e.target.value, "ether"))
                }
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              <b>Collateral Amount</b>
            </Col>
            <Col className="pl-0" xs={3.5}>
              <TextInput
                placeholder="Value of collateral in %"
                fieldType="number"
                onChange={(e) =>
                  setCollateralAmount(web3.utils.toWei(e.target.value, "ether"))
                }
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              <b>Trade Fee</b>
            </Col>
            <Col className="pl-0" xs={3.5}>
              <TextInput
                placeholder="Value of trade fee in %"
                fieldType="number"
                onChange={(e) =>
                  setTradeFee(web3.utils.toWei(e.target.value, "ether"))
                }
                required
              />
            </Col>
          </Row>
          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              <b>Brokerage</b>
            </Col>
            <Col className="pl-0" xs={3.5}>
              <DropdownButton id="dropdown-basic-button" title={brokerage}>
                {BrokeragesList.map((Brk, idx) => (
                  <>
                    <Dropdown.Item
                      key={idx}
                      onClick={(e) => {
                        setBrokerage(e.target.textContent);
                      }}
                    >
                      {Brk}
                    </Dropdown.Item>
                  </>
                ))}
              </DropdownButton>
            </Col>
          </Row>

          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col xs={{ span: 3, offset: 3 }} className="text-left">
              {brokerage !== "Select Brokerage" && (
                <b> Amount To Transfer To Brokerage({brokerage})</b>
              )}
              {brokerage === "Select Brokerage" && (
                <b> Amount To Transfer To Brokerage</b>
              )}
            </Col>
            <Col className="pl-0" xs={3.5}>
              <TextInput
                placeholder="Transfer Amount"
                fieldType="number"
                onChange={(e) =>
                  setBrokerageAmount(
                    ethers.utils.parseUnits(e.target.value?.toString(), 18)
                  )
                }
                required
              />
            </Col>
          </Row>

          <Row className="mx-0 mb-3 my-2 pl-0 width-100 align-items-center">
            <Col className="pl-0">
              <UiButton
                onClick={async () => {
                  handleIssueProduct();
                }}
                buttonVariant="primary"
                buttonClass="SignUpButton flex-1 ml-0"
                buttonText="Issue Product"
                type="submit"
              />
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
}

export default function CreateProduct(props) {
  return (
    <Route>
      <NewProduct {...props} />
    </Route>
  );
}
